// import axios from 'axios';
import { risingAPI } from "../baseApi";

export async function getFavCoinListData() {
  try {
    const res = await risingAPI.get(`/fav-coin-list`);
    // console.log('data',res.data);
    let result = res.data;
    // console.log('result',result);
    return result.data.favorites_list;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}
